import { Component, ViewChild, ElementRef, TemplateRef, QueryList, ViewChildren, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messageService } from 'src/app/message.service';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { qmsService } from '../../qms.service';
import { PaginationService } from 'src/app/PaginationService';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { forkJoin, from, of } from 'rxjs';
import { concatMap, tap, finalize, catchError } from 'rxjs/operators';

@Component({
  selector: 'app-oos-questions',
  templateUrl: './oos-questions.component.html',
  styleUrls: ['./oos-questions.component.scss']
})

export class OosQuestionsComponent implements OnInit {

  oosNo: any;

  labField: any = [];
  field: any = {};

  isProcessing: boolean = false;
  isAdding: boolean = false;

  fieldTypeList: any = [];
  fieldTypeDropDown: any = [];
  fieldTypeSearchText: string = '';
  isFrozen: boolean = this.message.isLabTabsFrozen;

  dateCustomClasses: DatepickerDateCustomClasses[];

  constructor(
    readonly qualityService: qmsService,
    readonly message: messageService,
    private readonly dialog: MatDialog,
    private readonly appService: AppService,
    private readonly paginationService: PaginationService,
    private readonly router: Router,
    private readonly snackBar: MatSnackBar,
    private readonly elem: ElementRef,
  ) {
    this.oosNo = this.qualityService.activityId;
    this.selectedPhaseTabIndex = 0;
    this.selectedPhaseTabName = 'PhaseI A';
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  };

  template: any = [];
  category: any = [];
  categories: any = [];
  phases: any = [{ phaseName: 'Phase I - A' }, { phaseName: 'Phase I - B' }];
  criteriaList: any = [];

  templateList: any = [];
  categoryList: any = [];

  templateDropDown: any = [];
  categoryDropDown: any = [];

  templateSearchText: string = '';
  categorySearchText: string = '';
  dropDownSearchText: string = '';
  selectedOption: string = '';
  selectedPhaseTabIndex: any;
  selectedPhaseTabName: string;

  onTabChanged($event: any) {
    this.selectedPhaseTabName = this.phases[$event.index].phaseName;
    this.selectedPhaseTabIndex = $event.index;
    this.ngOnInit();
  }

  ngOnInit() {
    this.isProcessing = true;
    this.qualityService.isChangeDetectedInOos = false;
    this.labField = [];
    this.getTemplate();
    this.loadQuestionCategories();
    this.loadFieldTypes();
    this.loadOosFields();
  }

  private loadOosFields() {
    this.appService.getAllByOosNoAndQcDept(this.oosNo, this.qualityService.selectedTabName, this.selectedPhaseTabName)
      .subscribe((fields: any) => {
        if (!fields?.length) return;

        fields.forEach((el: any) => {
          el.questionValues = el.questionValues?.split(',') ?? null;

          if (['Multiselect Drop Down', 'Vertical Checkbox Button', 'Horizontal Checkbox Button'].includes(el.questionTypeCode)) {
            el.dd = el.response ? el.response.split(',') : [];
          }

          el.multiSelection = el.dd?.length === el.questionValues?.length;
        });

        this.labField = fields;
        this.categories = fields
          .filter((item: any, index: number, self: any) => index === self.findIndex((s: any) => s.categoryName === item.categoryName))
          .sort((a: any, b: any) => a.categorySeq - b.categorySeq);

        this.isProcessing = false;
      });
  }

  private loadQuestionCategories() {
    this.appService.getCodeListsByGroup('OOS_QUESTION_CATEGORY').subscribe((category: any) => {
      this.criteriaList = category?.filter((c: any) =>
        this.qualityService.selectedTabName === 'Analytical' ? !['Sampling', 'Bacterial Endotoxin Test(BET)'].includes(c.codelistCode) : true);
      this.selectBoxForCategory();
    });
  }

  private loadFieldTypes() {
    this.appService.getNonOrgCodeListsByGroupName("FLEXIFIELD_FIELDTYPE").subscribe((type: any) => {
      this.fieldTypeList = type;
      this.selectBoxForFieldType();
    });
  }

  getTemplate() {
    this.appService.getAllLabTemplate().subscribe((template: any) => {
      this.templateList = template.filter((item: any) => item.qcSubDepartment == this.qualityService.selectedTabName);
      this.selectBoxForTemplate();
      this.isProcessing = false;
    })
  }

  selectBoxForTemplate() {
    this.templateDropDown = this.templateList?.map((type: any) => ({
      valueExp: type.templateId,
      displayExp: type.templateName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  onTemplateSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.templateSelection = this.templateDropDown.length == this.template.length;
      })
    }
  }

  getCategories(categories: any) {
    this.categories = categories.filter((item: any, index: number, self: any) => index == self.findIndex((s: any) => s.categoryName == item.categoryName));
  }

  selectBoxForCategory() {
    this.categoryList = this.criteriaList?.map((category: any) => ({
      valueExp: category.codelistCode,
      displayExp: category.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  onCategorySelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('category', item);
    }
  }

  onDeleteCategorySelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('delete-category', item);
    }
  }

  selectBoxForFieldType() {
    this.fieldTypeDropDown = this.fieldTypeList?.filter((f: any) => f.codelistName != 'Document Repository')?.map((type: any) => ({
      valueExp: type.codelistCode,
      displayExp: type.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  onFieldTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('field-type', item);
    }
  }

  focusSearch(value: any) {
    setTimeout(() => { let searchBox = document.getElementById(value); searchBox?.focus() }, 0)
  }


  getFieldsByCategory(categoryName: string): any[] {
    return this.labField.filter((f: any) => f.categoryName === categoryName)?.sort((a: any, b: any) => a.questionSeq - b.questionSeq);;
  }

  getColWidth(t: any): string {
    if (t === 'Large Text') return 'col-md-6';
    else return 'col-md-3';
  }

  openAddFieldPopup() {
    this.popupTitle = 'Add Field(s)';
    this.criteriaList = ['Choose from Template', 'Add Manually'];
    [this.selectedOption, this.template] = ['', []];
    this.visibleAddPopup = this.dialog.open(this.addPopup, this.addPopupConfig);
  }

  closeAddFieldPopup() {
    this.visibleAddPopup.close();
  }

  onPrimaryOptionChange(event: any) {

    if (event.value == 'Choose from Template') {
      this.template = [];
    } else {
      [this.category, this.field] = [null, {}];
    }
  }

  changeDetected() {
    this.qualityService.isChangeDetectedInOos = true;
  }

  addFromTemplate() {
    this.categoryList = [];
    this.isProcessing = true;

    const calls = this.template.map((id: any) =>
      this.appService.getAllFieldsByTemplateId(id)
    );

    forkJoin(calls).subscribe((results: any) => {
      // 'results' is an array of category arrays
      this.categoryList = results.flat();

      this.categoryList.forEach((element: any) => {
        element.isActive = element.isActive === "Y";
      });

      this.getCategories(this.categoryList);
      this.create();

      console.log("Category →", this.categoryList);
    });

  }

  responses: any[] = [];
  create() {
    const fields = this.categoryList?.filter((field: any) => field.isActive) ?? [];

    if (!fields.length) return;

    this.isProcessing = true;
    this.isAdding = true;
    this.responses = [];

    from(fields).pipe(
      concatMap((field: any, index: number) => {

        if (field.fieldTypeCode === 'Multiselect Drop Down' || field.questionTypeCode === 'Vertical Checkbox Button' || field.questionTypeCode === 'Horizontal Checkbox Button') {
          field.response = field.response?.length ? field.response.join(',') : null;
        } else if (field.fieldTypeCode === 'Date Field') {
          field.response = field.response ? new Date(field.response) : null;
        }

        const obj = {
          oosNo: this.oosNo,
          qcSubDepartment: this.qualityService.selectedTabName,
          categorySeq: field.categorySeq,
          categoryName: field.categoryName,
          questionSeq: field.fieldSeq,
          question: field.fieldName,
          questionIdTemplateId: field.templateId,
          questionTypeCode: field.fieldTypeCode,
          questionValues: field.fieldValues,
          response: null,
          instructions: field.instructions,
          phase: this.selectedPhaseTabName,
        };

        console.log("Sending →", obj);

        return this.appService.createOosQuestion(obj).pipe(
          tap((response: any) => {
            this.responses[index] = { field, response: response, };
          }),
          catchError((error) => {
            console.error("Error while creating question:", error);
            this.showSnackBar("One item failed to create", "E");
            return of(null); /* Continue to next */
          })
        );
      }),
      finalize(() => {
        this.isProcessing = false;
        this.visibleAddPopup.close();
        this.visibleResultPopup = this.dialog.open(this.resultPopup, this.resultPopupConfig);
      })
    ).subscribe();
  }

  update() {

    this.qualityService.isChangeDetectedInOos = false;
    if (!this.labField.length) return;

    this.isProcessing = true;
    this.isAdding = false;
    this.responses = [];

    from(this.labField).pipe(
      concatMap((field: any, index: number) => {

        if (field.questionTypeCode === 'Multiselect Drop Down' || field.questionTypeCode === 'Vertical Checkbox Button' || field.questionTypeCode === 'Horizontal Checkbox Button') {
          field.response = field?.dd?.length ? field.dd.join(',') : null;
        } else if (field.questionTypeCode === 'Date Field') {
          field.response = field.dd ? new Date(field.dd) : null;
        }

        const obj = {
          questionId: field.questionId,
          oosNo: this.oosNo,
          qcSubDepartment: this.qualityService.selectedTabName,
          categorySeq: field.categorySeq,
          categoryName: field.categoryName,
          questionSeq: field.questionSeq,
          question: field.question,
          questionIdTemplateId: field.questionIdTemplateId,
          questionTypeCode: field.questionTypeCode,
          questionValues: field.questionValues?.join(',') ?? null,
          response: field.response,
          phase: this.selectedPhaseTabName
        };

        console.log("Updating →", obj);

        return this.appService.updateOosQuestion(obj).pipe(
          tap((response: any) => {
            this.responses[index] = { field, response: response, };
          }),
          catchError((error) => {
            console.error("Failed to update:", field, error);
            this.showSnackBar("One update failed", "E");
            return of(null);  /* Continue to next */
          })
        );
      }),
      finalize(() => {
        this.isProcessing = false;
        this.visibleAddPopup.close();
        this.visibleResultPopup = this.dialog.open(this.resultPopup, this.resultPopupConfig);
      })
    ).subscribe();
  }

  addManually(field: any = {}) {

    const validations = [
      { condition: !field.fieldName, id: 'field-name' },
      { condition: !field.fieldTypeCode, id: 'field-type' },
      ...((field.fieldTypeCode != 'Large Text' && field.fieldTypeCode != 'Text Field') ? [{ condition: !field.fieldValues, id: 'field-values' }] : []),
    ]

    const invalidIds = validations.filter((validation) => validation.condition).map((validation) => validation.id);
    if (invalidIds.length > 0) {
      this.fieldValidation(invalidIds);
      this.showSnackBar("Please enter all Mandatory Fields!", "E");
    } else {
      this.isProcessing = true;

      const obj = {
        oosNo: this.oosNo,
        qcSubDepartment: this.qualityService.selectedTabName,
        categorySeq: this.categories?.find((c: any) => c.categoryName === this.category)?.categorySeq
          ?? (this.categories?.length ? Math.max(...this.categories.map((c: any) => c.categorySeq ?? 0)) + 1 : 1),
        categoryName: this.category,
        questionSeq: this.getFieldsByCategory(this.category).length + 1,
        question: field.fieldName,
        questionIdTemplateId: 0,
        questionTypeCode: field.fieldTypeCode,
        questionValues: field.fieldValues,
        response: null,
        instructions: field.instructions,
        phase: this.selectedPhaseTabName
      }
      this.execute(obj);
    }
  }

  execute(obj: any) {
    this.appService.createOosQuestion(obj).subscribe({
      next: (Response: any) => {
        if (Response.resultType == "S") {
          this.visibleAddPopup.close();
          this.ngOnInit();
        } else {
          this.isProcessing = false;
        }
        this.showSnackBar(Response.result, Response.resultType);
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  dateFormat: any = this.appService.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';
  commonDateConfig = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
  };

  fieldValidation(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId) as HTMLInputElement;
      element && (element.style.color = 'red');
    });
  }

  openDeletePopup() {
    this.selectedOption = '';
    this.deleteReason = '';
    this.category = null;
    this.tempArray = [];
    this.criteriaList = ['Delete All', 'Delete By Category'];
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  closeDeletePopup() {
    this.visibleDeletePopup.close();
  }

  onDeletionOptionChange(event: any) {
    if (event.value == 'Delete by Category') {
      this.parentCheckBox = false;
      this.category = null;
      this.tempArray = [];
    }
    this.deleteReason = '';
  }

  parentCheckBox: boolean = false;
  tempArray: any = [];

  onParentCheckBoxChanged(e: any) {
    if (e.target.checked) {
      this.parentCheckBox = true;
      this.tempArray = [];
      this.onParentChecked();
    } else {
      this.parentCheckBox = false;
      this.onParentUnChecked();
    }
  }

  onParentChecked() {
    for (const c of this.getFieldsByCategory(this.category)) {
      c.childCheckBox = true;
      this.tempArray.push({ questionId: c.questionId, question: c.question, questionIdTemplateId: c.questionIdTemplateId });
    }
  }

  onParentUnChecked() {
    this.getFieldsByCategory(this.category).every((user: any) => {
      user.childCheckBox = false; return true;
    })
    this.tempArray = [];
  }

  onChildCheckBoxChanged(e: any, childData: any, idx: any) {
    if (e.target.checked) {
      childData.childCheckBox = true;
      this.onChildChecked(childData);
    } else {
      childData.userChildCheckBox = this.parentCheckBox = false;
      this.onChildUnchecked(childData);
    }
  }

  onChildChecked(checked: any) {
    if (!this.tempArray?.some((x: any) => x.questionId === checked.questionId)) {
      this.tempArray.push({
        questionId: checked.questionId,
        question: checked.question,
        questionIdTemplateId: checked.questionIdTemplateId
      })
    }

    if (this.tempArray?.every((y: any) => y.userChildCheckBox)) this.parentCheckBox = true;
  }

  onChildUnchecked(unchecked: any) {
    const removal = this.tempArray?.findIndex((removable: any) => removable.questionId == unchecked.questionId);
    if (removal > -1) this.tempArray?.splice(removal, 1);
  }

  deleteReason: string = '';
  deleteMethod() {
    this.isProcessing = true;
    this.responses = [];

    const array = this.selectedOption == 'Delete All' ? this.labField : this.tempArray;

    from(array).pipe(
      concatMap((field: any, index: number) => {

        const obj = {
          questionId: field.questionId,
          oosNo: this.oosNo,
          question: field.question,
          questionIdTemplateId: field.questionIdTemplateId,
          deleteReason: this.deleteReason
        };

        console.log("Sending →", obj);

        return this.appService.deleteOosQuestion(obj).pipe(
          tap((response: any) => {
            this.responses[index] = { field, response: response, };
          }),
          catchError((error) => {
            console.error("Error while creating question:", error);
            this.showSnackBar("One item failed to create", "E");
            return of(null); /* Continue to next */
          })
        );
      }),
      finalize(() => {
        this.isProcessing = false;
        this.visibleDeletePopup.close();
        this.visibleResultPopup = this.dialog.open(this.resultPopup, this.resultPopupConfig);
      })
    ).subscribe();

  }


  @ViewChild('reorderPopup') reorderPopup: TemplateRef<any>;
  visibleReorderPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('addPopup') addPopup: TemplateRef<any>;
  visibleAddPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('resultPopup', { static: true }) resultPopup: TemplateRef<any>;
  visibleResultPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;

  reorderPopupConfig = {
    width: '800px',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  addPopupConfig = {
    width: '75%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  deletePopupConfig = {
    width: '75%',
    height: 'auto',
    hasBackdrop: true,
    position: { top: '30px' },
  };

  resultPopupConfig = {
    width: '32%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  cancelResultPopup() {
    this.visibleResultPopup.close();
    this.ngOnInit();
  }

  popupTitle: string = '';
  isReordered: boolean = false;
  selectedCriteria: string = '';
  selectedCategory: string = '';
  openReorderPopup() {
    this.popupTitle = 'Reorder';
    this.isReordered = false;
    this.criteriaList = ['Reorder Category', 'Reorder Fields'];
    this.selectedCategory = '';
    this.selectedCriteria = '';
    this.visibleReorderPopup = this.dialog.open(this.reorderPopup, this.reorderPopupConfig);
  }

  dragAndDrop(event: CdkDragDrop<string[]>) {
    this.isReordered = true;
    moveItemInArray(this.grid, event.previousIndex, event.currentIndex);
    for (let i = 0; i < this.grid.length; i++) {
      this.grid[i].NEW_ORDER = i + 1;
    }
  }

  grid: any = [];
  onSearchCriteriaChanged(criteria: any) {
    if (criteria == 'Reorder Category') {
      for (let i = 0; i < this.categories.length; i++) {
        this.categories[i].newSeq = i + 1;
      }
      this.grid = this.categories;
      console.log("Something..")
    } else if (criteria == 'Reorder Fields') {
      console.log("Something....")
    }
  }

  onCategoryReorderSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('category-name', item);
      console.log("DO");
    }
  }

  @ViewChild('templateRef', { static: false }) templateRef: MatSelect;
  templateSelection: boolean = false;
  @ViewChildren('multiselect') multiselect!: QueryList<MatSelect>;

  toggleAllSelection(value: any, field: any) {
    if (value == 'template') {
      if (this.templateSelection) this.templateRef.options.forEach((item: MatOption) => item.select());
      else {
        this.templateRef.options.forEach((item: MatOption) => item.deselect())
        this.template = [];
      }
      setTimeout(() => {
        this.handleDropDownValidation('template-name', this.template);
      });
    } else if (value === 'multiselect') {
      const targetSelect = this.multiselect.find((select: MatSelect) =>
        select._elementRef.nativeElement.dataset.fieldId == field.questionId
      );

      if (targetSelect) {
        if (field.multiSelection) {
          targetSelect.options.forEach((item: MatOption) => item.select());
        } else {
          targetSelect.options.forEach((item: MatOption) => item.deselect());
          field.dd = [];
        }
      }
    }
  }

  onMultiSelect(event: any, field: any) {
    if (event.isUserInput) {
      setTimeout(() => { field.multiSelection = field.questionValues.length == field.dd.length; })
    }
  }

  onCheckboxChange(event: any, value: string, field: any): void {
    if (event.checked) {
      field.dd.push(value);
    } else {
      let index = field.dd.indexOf(value);
      field.dd.splice(index, 1)
    }
  }

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;

    field && (field.style.color = items ? '#005c8a' : 'red');
    !field && console.error('Unable to find the element. Id → ', fieldId);
  }

  handleDropDownValidation(fieldId: string, selectedItems: any[] | string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isMultiSelectValidation = (fieldId === 'category-name');
    const shouldBeRed = isMultiSelectValidation ? !selectedItems.length : !selectedItems;

    field && (field.style.color = shouldBeRed ? 'red' : '#005c8a');
    !field && console.log('Unable to find the element. Id → ', fieldId);
  }

  snackbarRef: any;
  showSnackBar(message: string, type: string) {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }

  reorderItems() {
    if (this.selectedCriteria == 'Reorder Category') {
      console.log("Category ... ");
    } else {
      console.log("Fields ... ");
    }
  }

  cancelReorder() {
    this.visibleReorderPopup.close();
  }

}
